export default __webpack_public_path__ + "236969ac7dbe8bb97df222a8aeda1da8.webp";